import PropTypes from 'prop-types';
import classNames from 'classnames';
import { UNKNOWN_TIME, SHORT_UNKNOWN_TIME } from '../../../../constants/symbols';
import TripEndTimeTooltip from '../../trip/TripEndTimeTooltip';
import * as Styled from './Style';
export const Point = ({
  point: {
    title,
    description,
    datetime,
    isTransferPoint,
    isCheckPoint,
    arrivalTime
  },
  expanded,
  isFirst,
  isLast,
  hasManySegments
}) => {
  const isSecondaryPoint = !isFirst && !isLast;
  const isTripHasOneTransferPoint = isTransferPoint && !hasManySegments;
  return /*#__PURE__*/React.createElement(Styled.Item, {
    isExpanded: expanded,
    isSecondaryPoint: isSecondaryPoint,
    isFilled: isTransferPoint && hasManySegments,
    isBigPoint: hasManySegments && (isFirst || isLast),
    isTransferPoint: isTripHasOneTransferPoint
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Styled.Time, {
    isSecondaryPoint: isSecondaryPoint
  }, datetime ? I18n.l('time.formats.schedule_time', datetime) : arrivalTime || UNKNOWN_TIME), !isSecondaryPoint && datetime && /*#__PURE__*/React.createElement(Styled.Date, null, I18n.l('date.formats.short_date_month', datetime))), /*#__PURE__*/React.createElement("div", null, isTripHasOneTransferPoint && /*#__PURE__*/React.createElement(Styled.TransferText, null, I18n.t('pages.search.trip.transfer_title'), /*#__PURE__*/React.createElement(Styled.TransferCity, null)), /*#__PURE__*/React.createElement(Styled.City, {
    isSecondaryPoint: isSecondaryPoint,
    isPrimary: isCheckPoint
  }, title), /*#__PURE__*/React.createElement(Styled.Address, {
    isSecondaryPoint: isSecondaryPoint,
    isMuted: isSecondaryPoint
  }, description)));
};
export const MobilePoint = ({
  point: {
    title,
    description,
    datetime,
    isArrivalDayIsNextDay
  },
  isFirst,
  isLast,
  hasManySegments,
  tripSegmentsIdx
}) => {
  const isBetweenPoint = !isLast && !isFirst;
  const isShownDay = isArrivalDayIsNextDay && isLast;
  const isShownDayFirstSegment = hasManySegments && tripSegmentsIdx === 0;
  const tooltipIcon = /*#__PURE__*/React.createElement("i", {
    className: "icon icon-decline text-primary"
  });
  let body;
  if (datetime) {
    body = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, I18n.l('time.formats.schedule_time', datetime)), isShownDay && /*#__PURE__*/React.createElement("span", {
      className: classNames('day', {
        'hidden-day': isShownDayFirstSegment
      })
    }, I18n.l('date.formats.short_date_month', datetime)));
  } else {
    body = /*#__PURE__*/React.createElement(React.Fragment, null, !isLast && /*#__PURE__*/React.createElement("span", null, SHORT_UNKNOWN_TIME), isLast && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, SHORT_UNKNOWN_TIME), /*#__PURE__*/React.createElement(TripEndTimeTooltip, {
      className: "visible-xxs",
      icon: tooltipIcon
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "new-segment__item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-segment__time"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('time-to', {
      'flexed-row': !datetime
    })
  }, body)), /*#__PURE__*/React.createElement("div", {
    className: "new-segment__address"
  }, isBetweenPoint && /*#__PURE__*/React.createElement("span", null, title, ', '), /*#__PURE__*/React.createElement("span", {
    className: classNames({
      'text-muted': isBetweenPoint
    })
  }, description)));
};
// eslint-disable-next-line no-multi-assign
Point.propTypes = MobilePoint.propTypes = {
  point: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    isTransferPoint: PropTypes.bool,
    isCheckPoint: PropTypes.bool,
    datetime: PropTypes.instanceOf(Date),
    isArrivalDayIsNextDay: PropTypes.bool
  }).isRequired,
  hasManySegments: PropTypes.bool,
  tripSegmentsIdx: PropTypes.number,
  isFirst: PropTypes.bool.isRequired,
  isArrivalDayIsNextDay: PropTypes.bool,
  isLast: PropTypes.bool.isRequired
};